<template>
  <div id="catalogoJob" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="puesto"
    >
      <v-row no-gutters class="titulo catalogoTitle"
        >Definición de Puestos de Trabajo</v-row
      >
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2">Selecciona la Empresa</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="estructura" id="estructura" v-model="estructura">
            <option disabled value="0">Selecciona estructura</option>
            <option
              v-for="carga in structure"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2" v-if="estructura == 2"
          >Empresa Pagadora</v-col
        >
        <v-col cols="12" sm="4" class="py-2 selectGris" v-if="estructura == 2">
          <select
            name="pagadora"
            id="pagadora"
            v-model="enterprise"
            @change="obtenerAreasTrabajos()"
          >
            <option disabled value="0">Selecciona empresa</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Selecciona el tipo de carga</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="location" id="location" v-model="carga">
            <option disabled value="0">Selecciona carga</option>
            <option
              v-for="carga in cargas"
              :key="carga.id"
              v-bind:value="carga.id"
            >
              {{ carga.nombre }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-1" v-if="carga == 2">
          <p style="font-size: 18px">
            <i style="color: #0f6c21" class="fas fa-file-excel"></i>
            <a href="#" @click="descargaExcel()">&nbsp;&nbsp;Descargar</a>
            plantilla de excel para llenar.
          </p>
        </v-col>

        <v-col
          cols="12"
          sm="12"
          class="uploadfile p-0 pb-0 pt-2"
          v-if="carga == 2"
        >
          Subir archivo de Excel con la lista de puestos a registrar
          <input
            type="file"
            id="archivo"
            lang="es"
            class="pb-2"
            ref="fileUploadPerfilEdit"
            @click="resetFile"
            @change="previewFiles($event)"
          />
        </v-col>
        <br />
        <v-col cols="12" sm="12" class="mt-3 pa-0" align-self="end">
          <button class="boton" @click="validacion()">Siguiente</button>
          <router-link to="/jobList">
            <button class="boton">Regresar</button>
          </router-link>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>

    <v-container
      fluid
      class="base text-center ma-0 px-0 pt-6 pb-0"
      v-if="lista"
    >
      <v-row no-gutters class="titulo catalogoTitle">Alta de Puesto</v-row>
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2">Empresa Pagadora</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="estructura"
            id="estructura"
            v-model="enterprise"
            @change="obtenerAreasTrabajos()"
          >
            <option disabled value="0">Selecciona empresa</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="nomarea">Área a la que reporta</label>
        </v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="areaRep" id="areaRep" v-model="area">
            <option disabled value="0">Selecciona</option>
            <option v-for="area in areas" :key="area.id" v-bind:value="area.id">
              {{ area.nombreArea }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="puestoRep">Puesto al que reporta</label>
        </v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="puestoRep" id="puestoRep" v-model="jobr">
            <option v-for="job in jobs" :key="job.id" v-bind:value="job.id">
              {{ job.nombrePuesto }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Número de posiciones</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="posicion" id="posicion" v-model="posicion">
            <option disabled value="0">Selecciona</option>
            <option
              v-for="level in niveles"
              :key="level.id"
              v-bind:value="level.id"
            >
              {{ level.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Nombre del Puesto</v-col>
        <v-col cols="12" sm="4" class="py-2 inputEnterprise">
          <input
            type="text"
            id="nomPuesto"
            name="nomPuesto"
            maxlength="30"
            placeholder="Obligatorio"
            autocomplete="false"
            v-model="job"
            required
            @keypress="alfaNumerico($event)"
            style="
              width: 90% !important;
              margin-left: 0;
              padding-left: 3% !important;
            "
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Clave del Puesto</v-col>
        <v-col cols="12" sm="4" class="py-2 inputEnterprise">
          <input
            type="text"
            id="keyPuesto"
            name="keyPuesto"
            maxlength="30"
            placeholder="Obligatorio"
            autocomplete="false"
            v-model="key"
            required
            @keypress="alfaNumerico($event)"
            style="
              width: 90% !important;
              margin-left: 0;
              padding-left: 3% !important;
            "
          />
        </v-col>
        <v-col>
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacionPuesto()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>

    <!--Error-->
    <v-dialog v-model="error" width="380">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ titulo }}</span>
        </v-card-title>
        <v-card-text>
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            ¿Esta seguro de almacenar el tipo de puesto?
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="
              cancel();
              advice = false;
            "
            >Cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardarPuesto()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Puesto</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-sm-center text-md-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      show: false,
      stepn: "5-N",
      error: false,
      advice: false,
      confirmation: false,
      errors: [],
      estructura: 0,
      niveles: [],
      structure: [
        {
          id: 1,
          nombre: "Empresa Comercial",
        },
        {
          id: 2,
          nombre: "Empresa Pagadora",
        },
      ],
      respuesta: "",
      titulo: "",
      nivel: 0,
      carga: 0,
      cargas: [
        {
          id: 1,
          nombre: "Manual",
        },
        {
          id: 2,
          nombre: "Automatica",
        },
      ],
      pagadora: 0,
      enterprises: [],
      enterprise: 0,
      puesto: true,
      lista: false,
      area: 0,
      areas: [],
      jobs: [],
      posicion: 0,
      nombreArea: "",
      nombreCorto: "",
      nombreArchivo: "",
      job: "",
      jobr: 0,
      key: "",
      selectedFile: "",
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 ]+$"); // Letras
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    validacion() {
      this.errors = [];
      if (this.estructura == 0 || this.carga == 0) {
        this.errors.push(
          "Debe especificar la estructura organizacional y/o el tipo de carga"
        );
        this.titulo = "Puestos de trabajo";
        this.error = true;
      }
      if (this.errors.length == 0) {
        if (this.carga == 2) {
          if (this.estructura == 1)
            this.enterprise = localStorage.idCommercialEnterprise;
          this.procesarExcel();
        } else {
          this.puesto = false;
          this.nombre();
          this.lista = true;
        }
      }
    },
    regresar() {
      this.lista = false;
      this.enterprise = 0;
      this.jobr = 0;
      this.key = "";
      this.job = "";
      this.area = 0;
      this.posicion = 0;
      this.stepn = "14-N";
      this.nombre();
      this.puesto = true;
    },
    validacionPuesto() {
      this.errors = [];
      if (this.enterprise == 0) {
        this.errors.push("Se debe especificar la empresa.");
      }
      if (this.area == "" || this.area == " ") {
        this.errors.push("Se debe especificar el Área a la que reporta.");
      }
      if (this.job == "" || this.job == " ") {
        this.errors.push("Se debe especificar el Nombre de Puesto.");
      }
      if (this.key == "" || this.key == " ") {
        this.errors.push("Se debe especificar la clave de Puesto.");
      }
      if (this.posicion == 0) {
        this.errors.push("Se debe especificar la posición Puesto.");
      }
      if (this.errors.length == 0) {
        this.advice = true;
      } else {
        this.titulo = "Alta de Puesto";
        this.error = true;
      }
    },
    guardarPuesto() {
      this.advice = false;
      this.show = true;
      axios
        .post(Server + "/puestos", {
          EmpresaId: this.enterprise,
          AreaReportaId: this.area,
          PuestoReportaId: this.jobr,
          NumeroPosiciones: parseInt(this.posicion),
          NombrePuesto: this.job,
          Clave: this.key,
        })
        .then((response) => {
          this.show = false;
          this.enterprise = "";
          this.area = 0;
          this.jobr = 0;
          this.posicion = 0;
          this.job = "";
          this.key = "";
          this.respuesta = "El Puesto fue guardado con éxito";
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.area = 0;
          this.jobr = 0;
          this.posicion = 0;
          this.job = "";
          this.key = "";
          this.respuesta = "El Puesto no fue almacenado";
          this.confirmation = true;
        });
    },
    descargaExcel() {
      this.show = true;
      axios(
        {
          //url: Server + "/puestos/plantilla/" + this.enterprise,
          url: Server + "/puestos/plantilla-puestos",
          method: "GET",
          responseType: "blob",
        },
        { useCredentails: true }
      ) // CORS
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var fecha = new Date();
          link.setAttribute("download", "Puestos" + fecha.getTime() + ".xlsx");
          document.body.appendChild(link);
          link.click();
          this.show = false;
        })
        .catch((e) => {
          this.show = false;
        });
    },
    resetFile() {
      this.$refs.fileUploadPerfilEdit.value = "";
    },

    procesarExcel: function () {
      this.advice = false;
      var data = new FormData();
      data.append("idEmpresa", this.enterprise);
      data.append("excel", this.selectedFile, this.selectedFile.name);
      this.show = true;
      axios
        //.post(Server + "/puestos/cargar/excel", data, {
        .post(Server + "/puestos/cargar/excel-puestos", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          /*console.log(response);
        if(response.status == 200)
        {
          this.respuesta = "Archivo procesado con éxito";
          this.confirmation = true;
        } else {
          this.titulo = "Archivo inválido";
          this.errors.push(
            "Por favor verifica los datos ingresados en el archivo excel."
          );
          this.error = true;
        }*/
          this.respuesta = "Archivo procesado con éxito";
          this.show = false;
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.titulo = "Archivo inválido";
          this.errors.push(
            "Por favor verifica los datos ingresados en el archivo excel."
          );
          this.error = true;
        });
    },
    previewFiles(event) {
      this.errors = [];
      console.log(event);
      this.nombreArchivo = event.target.files[0].name;
      this.nombreArchivo.toLowerCase();
      var regex = new RegExp("(.*?).(xlsx|xls)$");

      if (!regex.test(this.nombreArchivo)) {
        this.nombreArchivo = "";
        this.titulo = "Archivo inválido";
        this.errors.push(
          "No se permite el archivo que ingreso favor de ingresar archivo con layout predeterminado."
        );
        this.error = true;
      } else {
        this.selectedFile = event.target.files[0];
      }
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.enterprises = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    obtenerAreasTrabajos() {
      this.areas = [];
      this.show = true;
      axios
        .get(Server + "/areas/por-empresa/" + this.enterprise)
        .then((response) => {
          this.show = false;
          this.areas = response.data;
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });

      this.jobs = [];
      this.jobs.push({
        id: 0,
        nombrePuesto: "Ninguno",
      });
      this.show = true;
      axios
        .get(Server + "/puestos/por-empresa/" + this.enterprise)
        .then((response) => {
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            this.jobs.push({
              id: value.id,
              nombrePuesto: value.nombrePuesto,
            });
          });
          this.show = false;
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
    },
    cancel() {
      this.enterprise = 0;
      this.job = "";
      this.key = "";
      this.jobr = 0;
      this.area = 0;
      this.posicion = 0;
    },
    aux() {
      this.confirmation = false;
      this.$router.push("/jobList");
    },
  },
  created() {
    this.nombre();
    this.listar();
    for (let index = 1; index <= 99; index++) {
      this.niveles.push({
        id: index,
        name: index.toString(),
      });
    }
  },
};
</script>